<script>
    import _ from 'lodash';
    import {store, api} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';

    const user = store('credentials', 'appUserAuth');
    
    // form data
    let login = ($user.email ? $user.email : ''),
        password = ($user.pasport ? $user.pasport : ''),
        name = ($user.name ? $user.name : ''),
        gorod = ($user.gorod ? $user.gorod : ''),
        tel = ($user.tel ? $user.tel : ''),
        adres = ($user.adres ? $user.adres : ''),
        ves = +($user.ves ? $user.ves : ''),
        rost = +($user.rost ? $user.rost : '');
    
    const fetchGorodList = (async () => {
        let result = await api('getGorod');
        return result.data ? result.data : [];
    })();

    const handlerClick = async () => {
        let popup = new bootstrap.Modal(document.getElementById('form-saved'));
        
        if (login && password) {
            await api('saveMembersData', {login, password, name, gorod, tel, adres, ves, rost});
            await user.load({login, password});
    
            popup.show();
            setTimeout(() => popup.hide(), 2500);
        }
    };
</script>

<TopMenu title="Анкета участника">
    <TopMenu_BackBtn slot="back" href="/dashboard" />
</TopMenu>

<div id="appCapsule">
    <div class="section mt-1 mb-5">
        <form>
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                    <div class="card">
                        <div class="card-header">Основная информация участника</div>
                        
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label for="name">Фамилия Имя Отчество</label>
                                            <input type="text" class="form-control" id="name" name="name" placeholder="Иванка" bind:value={name}>
                                            <p class="text-small text-muted mb-0">Полностью</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label for="name">Телефон</label>
                                            <input type="text" class="form-control" id="tel" name="tel" placeholder="+79001112233" bind:value={tel}>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label for="name">E-Mail</label>
                                            <input type="email" class="form-control" id="email" name="email" bind:value={$user.email} readonly>
                                            <p class="text-small text-muted mb-0">Нельзя редактировать</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label class="form-label" for="gorod">Город</label>
                                            {#await fetchGorodList}
                                                <select class="form-control form-select" required>
                                                    <option value="null" selected disabled>Загрузка</option>
                                                </select>
                                            {:then data}
                                                <select class="form-control form-select" id="gorod" name="gorod" bind:value={gorod}>
                                                    {#each data as {nameGorod}, i}
                                                        <option value="{nameGorod}">{nameGorod}</option>
                                                    {/each}
                                                </select>
                                            {/await}
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <!--<div class="row">
                                <div class="col-12">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label for="adres">Адрес</label>
                                            <textarea name="adres" id="adres" class="form-control" style="min-height:70px" bind:value={adres}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>-->
    
                            <hr>
                            
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label>Вес</label>
                                            <select class="form-control form-select" name="ves" bind:value={ves}>
                                                {#each _.range(40, 121) as i}
                                                    <option value="{i}">{i}</option>
                                                {/each}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label>Рост</label>
                                            <select class="form-control form-select" name="rost" bind:value={rost}>
                                                {#each _.range(120, 200) as i}
                                                    <option value="{i}">{i}</option>
                                                {/each}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        
                        <div class="card-footer">
                            <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerClick}>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    
        <div class="modal fade dialogbox" id="form-saved" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-icon text-success">
                        <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title">Сохранено</h5>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-inline">
                            <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
